// extracted by mini-css-extract-plugin
export default {"header":"ProgramConfigurationPage_header__xW5pH"};